import styled from 'styled-components';

export const DocumentsStyled = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
`;
